<template>
    <div v-loading="loading" class="offline-service-params">
        <div class="deploy-service-box">
            <h1>入参配置</h1>
            <hc-form
                key="tableFormObj"
                ref="tableFormObj"
                label-position="left"
                label-width="0"
                :model="tableFormObj"
                :rules="rulesObj"
                @validate="onTableFormObjValidateFunc"
            >
                <hc-table
                    :key="'table_' + varObj.paramType"
                    :data="tableFormObj.tableDataArr"
                    :style="getTableDataFn()"
                    :row-class-name="
                        ({ row, rowIndex }) => {
                            row.index = rowIndex
                            return errorRowIndex.includes(rowIndex)?'has_error':''
                        }
                    "
                    @row-click="row => $set(varObj, 'activeRowIndex', row.index)"
                >
                    <hc-table-column label="Key" width="308">
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="'tableDataArr.' + $index + '.key'"
                                :rules="rulesObj.key"
                            >
                                <hc-input v-model="row.key" class="key-input" type="text" placeholder="请输入key" size="mini" :disabled="isTenantApp ? !row.isTenant : false">
                                    <template v-if="isTenantApp && row.addField" :slot="row.customizeType === 0 ? 'prepend' : 'append'">
                                        {{ row.customizeField }}
                                    </template>
                                </hc-input>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column label="外部传入" width="120">
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="'tableDataArr.' + $index + '.sourceType'"
                                :rules="rulesObj.sourceType"
                            >
                                <hc-select
                                    :value="row.sourceType"
                                    size="mini"
                                    :disabled="isTenantApp ? !row.isTenant : false"
                                    @change="(v) => {
                                        row.sourceType = v
                                        if (v === 'dynamic') {
                                            row.value = ''
                                        } else {
                                            row.type = 'string'
                                        }
                                    }"
                                >
                                    <hc-option key="dynamic" label="是" value="dynamic" />
                                    <hc-option key="fixed" label="否" value="fixed" />
                                </hc-select>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column
                        label="值类型"
                        width="160"
                    >
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="'tableDataArr.' + $index + '.type'"
                            >
                                <hc-select v-model="row.type" :disabled="row.sourceType=='fixed' || isTenantApp ? !row.isTenant : false" placeholder="请选择值类型" size="mini">
                                    <hc-option key="number" label="Number" value="number" />
                                    <hc-option key="string" label="String" value="string" />
                                    <hc-option key="object" label="Object" value="object" />
                                    <hc-option key="objectArray" label="ObjectArray" value="objectArray" />
                                    <hc-option key="stringArray" label="stringArray" value="stringArray" />
                                    <hc-option key="numberArray" label="numberArray" value="numberArray" />
                                    <hc-option key="Boolean" label="Boolean" value="boolean" />
                                </hc-select>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column label="Value" width="268">
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="row.sourceType !== 'dynamic' ? 'tableDataArr.' + $index + '.value' : ''"
                                :rules="rulesObj.value"
                            >
                                <hc-input v-if="row.sourceType !== 'dynamic'"
                                    v-model="row.value"
                                    type="text"
                                    :disabled="isTenantApp ? !row.isTenant : false"
                                    placeholder="请输入Value"
                                    size="mini"
                                />
                                <hc-input v-else disabled type="text" placeholder="根据外部传入" size="mini" />
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column label="操作" min-width="168">
                        <template slot-scope="{ $index, row }">
                            <hc-button :disabled="isTenantApp ? !row.isTenant : false" type="text" @click="delParamFn(tableFormObj.tableDataArr, $index)">
                                删除
                            </hc-button>
                            <hc-button
                                v-if="varObj.hoverRowIndex === $index"
                                type="text"
                                :disabled="isTenantApp ? !row.isTenant : false"
                                @click="row => $set(varObj, 'activeRowIndex', $index)"
                            >
                                编辑
                            </hc-button>
                        </template>
                    </hc-table-column>
                </hc-table>
            </hc-form>
            <div
                v-if="isTenantApp ? validPurviewService.updateService : true"
                class="params-config-dialog__add-btn"
                @click="addParamFn(tableFormObj.tableDataArr)"
            >
                <span style="font-size: 16px;margin-right:4px;" class="hc-icon-circle-plus-outline" />
                <span>新增</span>
            </div>
        </div>

        <div class="deploy-service-box response-form">
            <h1>
                返回值
            </h1>
            <hc-form ref="responseForm" key="responseForm" :class="{'collapse': responseCollapse}" label-width="112px" :model="apiParamObj.response">
                <div class="row">
                    <hc-form-item
                        label="返回类型"
                        prop="dataType"
                        :rules="[{ required: true, message: '请选择数据返回类型', trigger: ['blur', 'change'] }]"
                    >
                        <hc-select v-model.trim="apiParamObj.response.dataType" placeholder="请选择返回类型" size="mini" :disabled="(isTenantApp && !apiParamObj.isTenant)">
                            <hc-option key="string" label="String" value="string" />
                            <hc-option key="number" label="Number" value="number" />
                            <hc-option key="boolean" label="Boolean" value="boolean" />
                            <hc-option key="object" label="Object" value="object" />
                            <hc-option key="objectArray" label="ObjectArray" value="objectArray" />
                            <hc-option key="stringArray" label="StringArray" value="stringArray" />
                            <hc-option key="numberArray" label="NumberArray" value="numberArray" />
                        </hc-select>
                    </hc-form-item>
                    <hc-form-item
                        v-if="apiParamObj.response.dataType === 'object' || apiParamObj.response.dataType === 'objectArray'"
                        :key="apiParamObj.response.objectId"
                        label="业务对象"
                        prop="objectId"
                        :rules="[{ required: true, message: '请选择业务对象', trigger: ['blur'] }]"
                    >
                        <object-picker
                            v-model="apiParamObj.response.objectId"
                            :object-name.sync="apiParamObj.response.objectName"
                            :business-env-id="businessEnvId"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                        />
                    </hc-form-item>
                </div>
                <div class="row">
                    <hc-form-item
                        label="判断依据字段"
                        prop="codeName"
                        :rules="[{ required: true, message: '请填写判断依据字段', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.codeName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入判断依据字段"
                            size="mini"
                        />
                    </hc-form-item>
                    <hc-form-item
                        label="成功值"
                        prop="successCodeValue"
                        :rules="[{ required: true, message: '请填写成功值', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.successCodeValue"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入成功值"
                            size="mini"
                        />
                    </hc-form-item>
                </div>

                <div class="row">
                    <hc-form-item
                        label="错误消息字段"
                        prop="msgName"
                        :rules="[{ required: true, message: '请填写错误消息字段', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.msgName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入错误消息字段"
                            size="mini"
                        />
                    </hc-form-item>
                    <hc-form-item
                        label="数据内容字段"
                        prop="dataName"
                        :rules="[{ required: true, message: '请填写数据内容字段', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.dataName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入数据内容字段"
                            size="mini"
                        />
                    </hc-form-item>
                </div>
                <div class="row">
                    <hc-form-item
                        v-if="apiParamObj.response.dataType === 'objectArray'"
                        prop="totalName"
                    >
                        <template slot="label">
                            <span>
                                总条数字段
                                <hc-tooltip class="item" effect="dark" content="该字段需要配合列表组件的是否显示总条数来控制" placement="top">
                                    <i class="hc-icon-question" style="margin-left: 2px;font-size: 14px;position: relative;top:1px" />
                                </hc-tooltip>
                            </span>
                        </template>
                        <hc-input
                            v-model.trim="apiParamObj.response.totalName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入总条数字段"
                            size="mini"
                        />
                    </hc-form-item>
                </div>
            </hc-form>

            <h4 class="expand-btn" :class="{'collapse': responseCollapse}" @click="responseCollapse = !responseCollapse">
                高级解析规则
                <i class="el-icon-arrow-down" />
            </h4>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import * as T from '@common/store/app-resource/types'
import { APP_RESOURCE } from '@common/store/module-types'
import ObjectPicker from '../object/object-picker'
import paramMixin from '../mixins/param'

export default {
    name: 'OfflineServiceParams',
    components: {
        ObjectPicker,
    },
    mixins: [paramMixin],
    props: {
        varObj: {
            type: Object,
            require: true,
        },
        apiParamObj: {
            type: Object,
            require: true,
        },
        rulesObj: {
            type: Object,
            require: true,
        },
        isCustomCreated: {
            type: Boolean,
        },
        businessEnvId: {
            type: String,
        },
    },
    data() {
        return {
            // 请求接口的参数
            tableFormObj: {
                tableDataArr: [],
            },
            errorRowIndex: [],
            loading: false,
            mockDataRules: [
                { required: true, message: 'mock数据不能为空', trigger: ['blur'] },
            ],
        }
    },
    watch: {
        tableFormObj: {
            deep: true,
            handler(val) {
                this.$emit('change-temp-param', val.tableDataArr)
            },
        },
    },
    mounted() {
        this.changeRequestBodyFn('formData')
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getObject: T.GET_NEW_OBJECT,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
        }),
        // 删除参数
        delParamFn(arr, index) {
            arr.splice(index, 1)
        },
        validate(cb) {
            this.$refs.responseForm.validate(responseValid => cb(responseValid))
        },
        resetFields() {
            this.$refs.responseForm.resetFields()
        },
        // 增加参数
        addParamFn(arr) {
            this.$refs.tableFormObj.validate(valid => {
                if (valid) {
                    const params = {
                        key: '',
                        sourceType: 'dynamic',
                        type: 'string',
                        // headers 设置为非必填，任务：https://www.tapd.cn/61118254/bugtrace/bugs/view?bug_id=1161118254001074270
                        required: false,
                    }
                    if (this.isTenantApp) {
                        params.isTenant = true
                        const { addField, customizeField, customizeType } = this.validPurviewObject

                        if (addField && !this.apiParamObj.isTenant) {
                            params.addField = addField
                            params.customizeField = customizeField
                            params.customizeType = customizeType
                        }
                    }
                    arr.push(params)
                    this.$set(this.varObj, 'activeRowIndex', arr.length - 1)
                }
            })
        },
        getTableDataFn() {
            if (this.varObj.paramType === 'request') {
                if (!this.apiParamObj.body) {
                    this.apiParamObj.body = {}
                }
                if (this.varObj.requestBody === 'formData') {
                    this.apiParamObj.body.object = {}
                }
                this.$set(this.tableFormObj, 'tableDataArr', this.apiParamObj.body.params)

                return this.apiParamObj.body.params || []
            }

            this.$set(this.tableFormObj, 'tableDataArr', this.apiParamObj[this.varObj.paramType])
            return this.apiParamObj[this.varObj.paramType]
        },
        async getObjectDtlFn(obj, id) {
            if (!id) {
                return
            }
            try {
                const resData = await this.getObjectDtl({
                    objectId: id,
                })
                this.$set(obj, 'objectName', resData.title)
            } catch (error) {
                // this.$message.error(error.message)
            }
        },
        // 改变请求体请求方式
        changeRequestBodyFn(val) {
            this.apiParamObj.body = this.apiParamObj.body || {}
            if (val === 'formData') {
                this.$set(this.apiParamObj.body, 'type', 'params')
                if (!this.apiParamObj.body.params) {
                    this.apiParamObj.body.params = []
                }
            }
        },

        onTableFormObjValidateFunc(option, status) {
            const index = option && option.indexOf('.') + 1
            const errorRowIndex = [...this.errorRowIndex]
            const rowIndex = parseInt(option.slice(index, index + 1), 10)
            if (!status) {
                errorRowIndex.push(rowIndex)
            } else {
                _.remove(errorRowIndex, item => item === rowIndex)
            }
            this.errorRowIndex = [...errorRowIndex]
        },
    },
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';
@import url('./common.less');
.params-config-dialog {
    &__add-btn {
        display: inline-flex;
        align-items: center;
        height: 28px;
        text-align: center;
        border-radius: 3px;
        margin-top: 12px;
        color: #2a6aff;
        font-size: 12px;
        cursor: pointer;
        padding: 0 8px;
        border: 0 solid rgba(80,122,254,1);
        background-color: white;
        transition: background-color .3s;

        &:hover {
            background-color: rgba(245,245,245,1);
        }
    }
}
.param-type__wraper {
    .param-type__item {
        display: inline-block;
        cursor: pointer;
        margin-right: 26px;
        &__icon {
            display: inline-block;
            position: relative;
            border: 2px solid #d3d8e9;
            border-radius: 100%;
            width: 16px;
            height: 16px;
            background-color: #fff;
            cursor: pointer;
            margin-right: 12px;
            box-sizing: border-box;
        }
        &__icon--active {
            border-color: #4c99fe;
        }
        &__icon--active::after {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 100%;
            background-color: #4c99fe;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        > span {
            vertical-align: middle;
        }
    }
}
.offline-service-params {
    @{deep} .object-picker__body {
        //width: 400px;
    }
    .hc-input{
        display: block;
        &.key-input {
            display: inline-table;
        }
    }
    @{deep} .hc-input--mini .hc-input__inner{
        height: 32px;
        display: block;
    }
    @{deep} .hc-table .hc-form-item{
        margin: 0;
    }
    @{deep} .hc-table .hc-table__row.has_error{
        .hc-form-item{
            margin: 15px 0 20px;
        }
    }
    @{deep} .hc-form-item__error{
        padding-top: 0;
        line-height: 17px;
    }
    .hc-form.response-form{
        margin-top: 24px;
    }

    /deep/ .hc-form-item__content > .object-picker {
        margin-top: 4px;

        .object-picker__body {
            font-size: 12px;
            padding-left: 8px;
            color: #222;
        }
    }

    /deep/ .hc-table {
        th.hc-table__cell.is-leaf {
            border-color: #EAEAEA;
            padding: 8px 0;
            font-size: 13px;
            font-weight: 400;
            background: #FBFBFB;
        }

        .hc-table td.hc-table__cell {
            border-color: #EAEAEA;
        }

        .hc-input__suffix {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .hc-select {
            width: 100%;
        }
    }
}
.new-object .offline-service-params{
    @{deep} .hc-table .hc-form-item{
        margin: 0;
    }
}
</style>
